module.exports = __webpack_public_path__ + "img/announcement.a87c5bff.png";